import axios from 'axios'

const httpClient = axios.create({
    baseURL: `${import.meta.env.VITE_API_BASE_URL}/api/v2`,
    withCredentials: true,
})

// Helper function to get CSRF cookie
const getCsrfCookie = async () => {
    try {
        await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/v2/auth`, {
            withCredentials: true
        })
    } catch (error) {
        console.error('Failed to get CSRF cookie:', error)
    }
}

httpClient.interceptors.request.use(async (config) => {
    const csrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1]
    
    if (csrfToken) {
        const decodedToken = decodeURIComponent(csrfToken)
        config.headers['X-XSRF-TOKEN'] = decodedToken
    }
    
    return config
})

httpClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config

        if (error.response?.status === 419) {
            // CSRF token mismatch - get new token and retry
            if (!originalRequest._retry) {
                originalRequest._retry = true
                
                try {
                    // Get fresh CSRF cookie
                    await getCsrfCookie()
                    
                    // Get the new token from cookie
                    const newCsrfToken = document.cookie
                        .split('; ')
                        .find(row => row.startsWith('XSRF-TOKEN='))
                        ?.split('=')[1]
                    
                    if (newCsrfToken) {
                        const decodedToken = decodeURIComponent(newCsrfToken)
                        originalRequest.headers['X-XSRF-TOKEN'] = decodedToken
                    }
                    
                    // Retry the original request
                    return httpClient(originalRequest)
                } catch (retryError) {
                    console.error('Failed to retry request after 419:', retryError)
                    // Optionally redirect to login if retry fails
                    window.location.href = '/login'
                    return Promise.reject(retryError)
                }
            }
        }
        
        if (error.response?.status === 401) {
            // Handle unauthorized - redirect to login
            window.location.href = '/login'
        }
        
        return Promise.reject(error)
    }
)

export default httpClient